import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis, Tooltip, Legend, LabelList } from 'recharts';

interface VersionDeploymentData {
  region: string;
  latestVersionPercentage: number;
  totalSites: number;
  latestVersionSites: number;
}

interface VersionDeploymentByRegionChartProps {
  data: VersionDeploymentData[];
}

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div className="bg-background border border-border rounded-lg p-3 shadow-lg">
        <p className="font-medium">{label}</p>
        <p className="text-sm text-muted-foreground">
          Latest Version Deployment: {data.latestVersionPercentage.toFixed(1)}%
        </p>
        <p className="text-sm text-muted-foreground">
          {data.latestVersionSites} of {data.totalSites} active sites
        </p>
      </div>
    );
  }
  return null;
};

export const VersionDeploymentByRegionChart = ({ data }: VersionDeploymentByRegionChartProps) => {
  // Filter to distinct regions and sort by percentage
  const distinctData = data
    .filter((item, index, self) => 
      index === self.findIndex(t => t.region === item.region)
    )
    .filter(item => item.totalSites > 0)
    .sort((a, b) => b.latestVersionPercentage - a.latestVersionPercentage);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart 
        data={distinctData} 
        margin={{ top: 15, right: 10, left: 10, bottom: 20 }}
        barCategoryGap="20%"
      >
        <XAxis 
          dataKey="region" 
          tick={{ fontSize: 10, fill: 'hsl(var(--foreground))' }}
          angle={-45}
          textAnchor="end"
          height={50}
          interval={0}
        />
        <YAxis 
          tick={{ fontSize: 10, fill: 'hsl(var(--foreground))' }}
          domain={[0, 100]}
          ticks={[0, 25, 50, 75, 100]}
          axisLine={{ stroke: 'hsl(var(--border))' }}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend 
          wrapperStyle={{ 
            fontSize: '11px', 
            paddingTop: '5px',
            color: 'hsl(var(--foreground))'
          }}
        />
        <Bar 
          dataKey="latestVersionPercentage" 
          name="Latest Version %"
          fill="hsl(var(--primary))"
          radius={[4, 4, 0, 0]}
        >
          <LabelList 
            dataKey="latestVersionPercentage" 
            position="top"
            formatter={(value: number) => `${Math.round(value)}%`}
            style={{
              fontSize: '10px',
              fill: 'hsl(var(--foreground))',
              fontWeight: 'bold'
            }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};